import { Effect } from 'effect';

import type { OrderItems } from '../../bind/order';
import type { OrderDetail } from '../../schema/openapi/backend';
import type { OrderShipmentStorageT } from '../../service/orderShipment/OrderShipment';
import { TenantConfig } from '../../service/tenant/TenantConfig';
import { setOrderShipment as setOrderShipmentCookies } from '../../utils/cookies/orderShipment';
import { createAddPaymentInfoPayloadFromOrder } from '../../utils/gtm/create/add-payment-info';
import { createAddShippingInfoPayloadFromOrder } from '../../utils/gtm/create/add-shipping-info';
import { sendGtmEvent } from '../../utils/gtm/gtm';

export type SetOrderShipmentWithGtmEventsData = {
  orderShipmentData: OrderShipmentStorageT;
  orderData: OrderDetail;
  cartItems: OrderItems;
};

export default function setOrderShipment(data: SetOrderShipmentWithGtmEventsData) {
  return Effect.gen(function* () {
    const { currency } = yield* TenantConfig;

    // Save order shipment data
    yield* setOrderShipmentCookies(data.orderShipmentData);

    // Send GTM add_shipping_info event
    yield* createAddShippingInfoPayloadFromOrder(
      data.orderData,
      data.cartItems,
      data.orderShipmentData,
      currency
    ).pipe(Effect.flatMap((event) => sendGtmEvent(event, true)));

    // Send GTM add_payment_info event
    yield* createAddPaymentInfoPayloadFromOrder(
      data.orderData,
      data.cartItems,
      data.orderShipmentData,
      currency
    ).pipe(Effect.flatMap((event) => sendGtmEvent(event, true)));

    return data.orderShipmentData;
  });
}
